import { css } from "../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      display: "inline-flex",
      alignItems: "center",
      gap: "9px",
    }),
  label: () =>
    css({
      fontSize: "body.shrimp",
      lineHeight: "20px",
      fontWeight: 700,
      color: "darkGrey",
      whiteSpace: "nowrap",
    }),
  sideLabel: (active: boolean) =>
    css({
      fontSize: "body.shrimp",
      lineHeight: "20px",
      fontWeight: 700,
      whiteSpace: "nowrap",
      color: active ? "linkBlue" : "borderGrey",
      transition: "color 0.3s ease",
    }),
  track: (on: boolean) =>
    css({
      position: "relative",
      width: "44px",
      height: "24px",
      borderRadius: "100px",
      border: "none",
      padding: 0,
      cursor: "pointer",
      backgroundColor: on ? "linkBlue" : "lightGrey",
      transition: "background-color 0.3s ease",
      outlineOffset: "3px",
    }),
  thumb: (on: boolean) =>
    css({
      position: "absolute",
      top: "2px",
      left: on ? "22px" : "2px",
      width: "20px",
      height: "20px",
      borderRadius: "100px",
      backgroundColor: "white",
      boxShadow: "0px 1px 3px 0px rgba(16,24,40,0.1), 0px 1px 2px -1px rgba(16,24,40,0.1)",
      transition: "left 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
    }),
};
